import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function CommInstall() {
    return (
        <React.Fragment>
            <p>
                If your system is unable to complete an installation or upgrade, ensure that your server meets{' '}
                <a href="/jet/general/system-requirements">system requirements</a>. If you are upgrading your SDCX
                server and the installer fails, use the{' '}
                <a href="#operational-issues">operational troubleshooting instructions</a>.
            </p>
            <p>If a specific service fails to upgrade, uninstall and reinstall the SDCX server software.</p>
            <p>
                <strong>Note</strong>: For Windows installations, edit the registry and remove any entries related to
                the Signiant Communication Service.
            </p>
        </React.Fragment>
    );
}

CommInstall.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CommInstall);
